import { motion } from "framer-motion";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Route, Routes, useLocation } from "react-router-dom";
import { COMPONENTS, SPACING } from "../../../constants/design/spacing";
import { IPage } from "../../shared";
import { buildHistoricalTabs } from "../historicalTabs";
import {
  ContentsWrapper,
  InnerContentsWrapper,
  MobilePageWrapper,
  MobileTabActionsWrapper,
  MobileTabLinkWrapper,
} from "../../style";
import { PageEndpointEnum } from "../../../enums/endpoint";
import { useGetAccount } from "../../../hooks/api/account/useGetAccount";

function MobileHistoricalPage() {
  const location = useLocation();
  const activePage = useMemo(
    () => location.pathname.split(`${PageEndpointEnum.HISTORICAL}/`)[1],
    [location]
  );
  const { t } = useTranslation("app", { keyPrefix: "pages.HistoricalPage" });
  const { data: accountData } = useGetAccount();

  const pages: IPage[] = useMemo(
    () =>
      buildHistoricalTabs({
        t,
        activePage,
        positions: accountData?.positions,
        isMobile: true,
      }),
    [t, activePage, accountData?.positions]
  );

  return (
    <MobilePageWrapper>
      <MobileTabActionsWrapper>
        <div>
          {pages.map((page, i) => (
            <motion.div
              key={page.title}
              transition={{
                delay: i * 0.1,
                duration: 0.5,
                ease: "easeInOut",
              }}
              initial={{
                transform: "translateY(-8px)",
                opacity: 0,
              }}
              animate={{
                transform: "translateY(0px)",
                opacity: 1,
              }}
              exit={{
                opacity: 0,
              }}
            >
              <MobileTabLinkWrapper
                to={page.redirect}
                $isActive={page.isActive}
              >
                {page.title}
              </MobileTabLinkWrapper>
            </motion.div>
          ))}
        </div>
      </MobileTabActionsWrapper>
      <ContentsWrapper isMobileScreen>
        <InnerContentsWrapper
          isMobileScreen
          style={{
            paddingTop: COMPONENTS.portfolioNavigation,
            paddingLeft: SPACING.three,
            paddingRight: SPACING.three,
          }}
        >
          <Routes>
            {pages.map((page) => (
              <Route key={page.path} path={page.path} element={page.element} />
            ))}
          </Routes>
        </InnerContentsWrapper>
      </ContentsWrapper>
    </MobilePageWrapper>
  );
}

export default MobileHistoricalPage;
